module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<button class=\"mb-0 d-none d-md-block btn btn-secondary filter-card-btn\" type=\"button\">Create New BOL</button> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/fulfillment_bols/create/template.ejs
// module id = 1665
// module chunks = 1